<template>
  <!-- ユーザ管理画面 -->
  <CCard>
    <CCardHeader>
      <h2>
        <span>ユーザ管理</span>
        <span class="card-header-actions">
          <!-- 登録画面へ遷移するボタン -->
          <router-link :to="{ name: registerTop }">
            <button class="btn btn-primary">新規登録</button>
          </router-link>
        </span>
      </h2>
    </CCardHeader>
    <CCardBody>
      <CRow v-if="errors.length">
        <ul>
          <li style="color: red" v-for="error in errors" :key="error">
            {{ error }}
          </li>
        </ul>
      </CRow>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th style="width: 16.6%" scope="col">社員番号</th>
              <th style="width: 16.6%" scope="col">氏名</th>
              <th style="width: 16.6%" scope="col">ユーザ種別</th>
              <th style="width: 16.6%" scope="col">有給日数</th>
              <th style="width: 16.6%" scope="col">代休日数</th>
              <th style="margin-left: 15px; width: 16.6%" class="title"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in items" :key="item.name">
              <td>{{ item.employee_id }}</td>
              <td>
                <router-link :to="{ name: info, params: { id: item.id } }">{{
                  item.name
                }}</router-link>
              </td>
              <td>{{ item.authority_name }}</td>
              <td class="position-right">{{ item.paid_days.toFixed(1) }}日</td>
              <td class="position-right">{{ item.comp_days.toFixed(1) }}日</td>
              <td>
                <button
                  v-on:click="openModal(item, index)"
                  class="btn btn-danger"
                >
                  削除
                </button>
                <!-- 削除モーダルコンポーネント呼出 -->
                <DeleteModal
                  :draggable="true"
                  :resizable="true"
                  :val="postItem"
                  :loading="loading"
                  v-show="showModal"
                  @delete="deleteUser"
                  @close="closeModal"
                >
                </DeleteModal>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <!-- ページング処理 -->
        <VPagination
          v-model="currentPage"
          :click-handler="changePage"
          :page-count="totalPages"
          :force-ellipses="true"
          :container-class="'pagination'"
          :page-class="'page-item'"
          :prev-text="'<'"
          :next-text="'>'"
          :prev-link-class="'page-link'"
          :next-link-class="'page-link'"
          :page-link-class="'page-link'"
          :class-prefix="'pagination'"
        />
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import ConstList from "./../ConstList";
import DeleteModal from "./DeleteModal";
import axios from "axios";
import VPagination from "vuejs-paginate";
export default {
  name: "List",
  components: {
    DeleteModal,
    VPagination,
  },
  data() {
    return {
      showModal: false,
      postItem: "",
      items: [],
      employee_id: [],
      deleted_flg: [],
      paid_days: "",
      comp_days: "",
      authority: [],
      errors: [],
      registerTop: "",
      info: "",
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      // 二重サブミット対処フラグ
      submit_flg: false,
      loading: false,
    };
  },

  created() {
    this.registerTop = ConstList.REGISTER_TOP;
    this.info = ConstList.ROUTE_INFO;
  },

  methods: {
    // 一覧表示
    callList: function () {
      const params = new URLSearchParams();
      params.append("currentPage", this.currentPage);
      params.append("pageSize", this.pageSize);
      {
        axios
          .get(process.env.VUE_APP_API_ORIGIN + "/users", {
            params: {
              currentPage: this.currentPage,
              pageSize: this.pageSize,
            },
          })
          .then((response) => {
            this.items = response.data;
            if (this.items.length === 0) {
              this.errors.push(ConstList.EMPTY);
            }
          })
          .catch((error) => {
            axios
            .get(
              `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
            )
            .then(() => {
              alert(ConstList.SYSTEM_ERROR);
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
            });
          });
      }
    },

    // モーダルを表示
    openModal: function (item, index) {
      // 二重サブミット対策
      if (this.submit_flg) return;
      this.postItem = item;
      this.postItem.authority_id = this.authority[index];
      this.showModal = true;
    },

    // ユーザを削除
    deleteUser: function () {
      this.loading = true;
      const params = new URLSearchParams();
      params.append("id", this.postItem.id);
      axios
        .post(process.env.VUE_APP_API_ORIGIN + "/delete", params)
        .then(() => {
          alert(ConstList.DELETE_MESSAGE);
          this.showModal = false;
          window.location.reload();
        })
        .catch((error) => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // モーダルを閉じる
    closeModal: function () {
      this.showModal = false;
    },

    // ページ変更
    changePage: function (page) {
      this.currentPage = page;
      console.log("123123123");
      this.callList();
    },

    // アイテム数とページサイズに基づいて合計ページ数を計算
    fetchTotalPages: function () {
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/users/count")
        .then((response) => {
          const totalCount = response.data;
          this.totalPages = Math.ceil(totalCount / this.pageSize);
        })
        .catch((error) => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        });
    },
  },

  // DBから各種情報を取得
  mounted: function () {
    this.callList();
    this.fetchTotalPages();
  },
};
</script>

<style scoped>
table {
  width: 100%;
}
.position-right {
  text-align: right;
  padding-left: auto;
  padding-right: 10%;
}
td {
  vertical-align: middle;
  white-space: nowrap;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
